import { ILeaseRate } from '../../../views/lease/i-leaserate.interface';
import { ICustomer } from '../../../views/customer/i-customer.interface';
import { IRailcarCPdNotificationData } from './i-railcarcpdnotificationdata.interface';

import { BusinessObject } from "../../../shared/business-object.model";
import { LeaseRate } from '../../../views/lease/lease-rate.model';
import { Customer } from '../../../views/customer/customer.model';

export class RailcarCPdNotificationData extends BusinessObject implements IRailcarCPdNotificationData {
	constructor(item: RailcarCPdNotificationData) {
		super(item);
	}

	notificationId: number;
	notificationCategory: string;
	leaseNumber: string;
	leaseRate: ILeaseRate;
	customer: ICustomer;
	prorateMonth: string;
	prorateAmount: number;
	arrivalDate: Date;
	traceResults: any[];
	prorateCalculationUsed: string;
	rent: any[];
}